/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import { isBlank } from '@ember/utils';
import Component from '@glimmer/component';
import CreateOrUpdatePersonAbstract from 'cio/app-models/action-abstracts/create-or-update-person';
import ApiService from 'cio/services/api';
import ApiErrorsService from 'cio/services/api-errors';
import { DataActionConditionType } from 'cio/utils/campaigns/data-action';

interface CreateOrUpdatePersonEditSidebarEditorArgs {
  actionAbstract: CreateOrUpdatePersonAbstract;
  isSaving: boolean;
  onSelect: () => unknown;
  onDeselect: () => unknown;
  hasReadOnlyPermission: boolean;
}
export default class CreateOrUpdatePersonEditSidebarEditor extends Component<CreateOrUpdatePersonEditSidebarEditorArgs> {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;

  get hasDetails() {
    return this.args.actionAbstract.recipientCondition.shouldMatchRecipient || this.rows.length > 0;
  }

  get rows() {
    let { action } = this.args.actionAbstract;

    if (action.isCreateOrUpdatePersonAttributeAction) {
      return this.args.actionAbstract.bodyRows.rows;
    }

    if (!action.hasContent) {
      return [];
    }

    return [
      {
        name: action.attributeName,
        type: isBlank(action.attributeName) ? DataActionConditionType.RemoveAttribute : DataActionConditionType.Liquid,
        value: action.attributeValue,
      },
    ];
  }
}
